import AppWrapper from './AppWrapper'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { appUrls } from '../../utils/urls/appUrls'
import '../../assets/css/layoutStyles.css'
import '../../assets/css/certifcateStyles.css'
import { clearAll, clearResponseMsg, clearOnReload, logoutNotapUser } from '../../config/redux/slice/notapUserSlice'
import { logoutAppUser, onGetCurrencies, setActiveSidebar } from '../../config/redux/slice/appSlice';
import { getRequest } from '../../helpers/request';
import { appApi } from '../../utils/endpoints/appApi';
import { handleOnPageLoad, handleOverlayClick } from '../../helpers/sideBarToggle';
import { logoutUser } from '../../config/redux/slice/authSlice';
import { logoutBankUser } from '../../config/redux/slice/bankUserSlice';
import { logoutTransfereeUser } from '../../config/redux/slice/transfereeUserSlice';

export default function NotapWrapper({children, pageTitle}) {
    const dispatch = useDispatch()
  const navigate = useNavigate()
  const {
        notapUserErrorMsg,
        notapUserSuccessMsg,
    } = useSelector((state) => state.notapUser)

  const {
        token,
        userData: {isProfileComplete, user_role}
    } = useSelector((state) => state.authData)

    const {isActive} = useSelector((state) => state.app)

    useEffect(()=>{
      dispatch(clearOnReload())
    dispatch(clearAll())
    }, [])

    const showToastMessage = (msg, isError) => {
      if(isError){
        toast.error(msg, {
            position: toast.POSITION.TOP_RIGHT
        });
      } else{
        toast.success(msg, {
            position: toast.POSITION.TOP_RIGHT
        });
      }
        
    };


    useEffect(()=>{
    if(notapUserSuccessMsg){
        let msg;
        if(Array.isArray(notapUserSuccessMsg)){
          msg = notapUserSuccessMsg[0].toLowerCase().charAt(0).toUpperCase() + notapUserSuccessMsg[0].slice(1)
        } else{
          msg = notapUserSuccessMsg.toLowerCase().charAt(0).toUpperCase() + notapUserSuccessMsg.slice(1)
        }

        dispatch(clearResponseMsg())

        showToastMessage(msg, false)
        
    }

    if(notapUserErrorMsg){
      let err
      if(Array.isArray(notapUserErrorMsg)){
        err = notapUserErrorMsg[0].toLowerCase().charAt(0).toUpperCase()+notapUserErrorMsg[0].slice(1)
      }
      else{
        err = notapUserErrorMsg.toLowerCase().charAt(0).toUpperCase()+notapUserErrorMsg.slice(1)
      }
        dispatch(clearResponseMsg())
        if(err == 'Invalid token'){
          dispatch(logoutUser())
          dispatch(logoutBankUser())
          dispatch(logoutAppUser())
          dispatch(logoutNotapUser())
          dispatch(logoutTransfereeUser())
          err = null
        }else{
          showToastMessage(err, true)
        }

        // showToastMessage(err, true)
    }
    }, [notapUserSuccessMsg, notapUserErrorMsg])

  return (
    <AppWrapper pageTitle={pageTitle}>
      <>
      {children}
      </>
    </AppWrapper>
  )
}
